module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fe4863d532234f0e9e15a3b51bb603eb.png";